var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 108C33.5325 108 12 86.4675 12 60C12 33.5325 33.5325 12 60 12C86.4675 12 108 33.5325 108 60C108 86.4675 86.4675 108 60 108ZM60 18C36.84 18 18 36.84 18 60C18 83.16 36.84 102 60 102C83.16 102 102 83.16 102 60C102 36.84 83.16 18 60 18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 108C52.0625 108 44.73 102.78 39.3575 93.3C34.29 84.3575 31.5 72.53 31.5 60C31.5 47.47 34.29 35.645 39.3575 26.7C44.73 17.22 52.06 12 60 12C67.94 12 75.27 17.22 80.6425 26.7C85.71 35.6425 88.5 47.47 88.5 60C88.5 72.53 85.71 84.355 80.6425 93.3C75.27 102.78 67.94 108 60 108ZM60 18C54.315 18 48.84 22.14 44.58 29.66C40.015 37.715 37.5 48.49 37.5 60C37.5 71.51 40.015 82.285 44.58 90.34C48.84 97.8575 54.3175 102 60 102C65.6825 102 71.16 97.86 75.42 90.34C79.985 82.285 82.5 71.51 82.5 60C82.5 48.49 79.985 37.715 75.42 29.66C71.16 22.1425 65.6825 18 60 18Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15H57V105H63V15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102 39H18V45H102V39Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105 57H15V63H105V57Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102 75H18V81H102V75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/Languages.6083a555.svg";
export { ForwardRef as ReactComponent };